import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "./../../../../api.js";
import './updateschema.css';
import Dashheader from '../../Dashheader/Dashheader';
import { useToasts } from "react-toast-notifications";
import utilis from "../../../../utilis";
// Ant Design and icons imports for Add Schema form
import { Form, Input, Button, DatePicker, Space, Divider, InputNumber } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";


const UpdateSchemas = () => {
  
  // State for toggling Add Schema form
  const [showAddSchemaForm, setShowAddSchemaForm] = useState(false);
  let navigate = useNavigate();
  const [schemaData, setSchemaData] = useState([]); // Changed to array
  const { addToast } = useToasts();
  const location = useLocation();
  const towerId = location.state?.towerId || "";

  useEffect(() => {
    const fetchschemaDetails = async () => {
      if (!towerId) {
        console.error("No tower ID found in storage");
        return;
      }
      try {
        const response = await api.getSchemaDetails(towerId);
        console.log("API Response:", response?.data);
        if (response.status === 401) {
          console.log("Session Expired! Redirecting to Login.");
          localStorage.removeItem(utilis.string.localStorage.sessionId);
          localStorage.removeItem(utilis.string.localStorage.userData);
          navigate('/');
        }
        if (response?.status === 200 && response?.data?.data?.length > 0) {
          // Set all schemas instead of first one
          setSchemaData(response.data.data);
          console.log("Updated schema Details:", response.data.data);
        } else {
          console.error("Invalid data received from API");
        }
      } catch (error) {
        console.error("Error fetching schema details:", error);
      }
    };
    fetchschemaDetails();
  }, [towerId]);

  const updatePhaseStatus = (schemaIndex, phaseIndex, isActive) => {
    const updatedData = [...schemaData];
    updatedData[schemaIndex].phases[phaseIndex].isActive = isActive;
    setSchemaData(updatedData);
  };

  const updatePhaseDate = (schemaIndex, phaseIndex, field, value) => {
    const updatedData = [...schemaData];
    updatedData[schemaIndex].phases[phaseIndex][field] = value;
    setSchemaData(updatedData);
  };

  const updateSchemeValue = (schemaIndex, phaseIndex, schemeIndex, field, value) => {
    const updatedData = [...schemaData];
    updatedData[schemaIndex].phases[phaseIndex].scheme[schemeIndex][field] = value;
    setSchemaData(updatedData);
  };

  const updateSchemeStatus = (schemaIndex, phaseIndex, schemeIndex, isActive) => {
    const updatedData = [...schemaData];
    updatedData[schemaIndex].phases[phaseIndex].scheme[schemeIndex].isActive = isActive;
    setSchemaData(updatedData);
  };

  const handleUpdatePhase = async (schemaIndex, phase) => {
    const body = {
      towerId: schemaData[schemaIndex].towerId,
      phaseId: phase._id,
      startDate: phase.startDate,
      endDate: phase.endDate,
      isActive: phase.isActive,
    };

    try {
      const response = await api.updatePhaseDetails(body);
      console.log("Update Phase Response:", response?.data);

      if (response?.status === 200) {
        addToast("Phase updated successfully!", { appearance: "success", autoDismiss: true, autoDismissTimeout: 5000 });
      } else if (response?.status === 401) {
        addToast("Session expired. Please login again.", { appearance: "error", autoDismiss: true, autoDismissTimeout: 5000 });
        localStorage.removeItem(utilis.string.localStorage.sessionId);
        localStorage.removeItem(utilis.string.localStorage.userData);
        navigate('/');
      } else {
        addToast("Failed to update phase. Please try again.", { appearance: "error", autoDismiss: true, autoDismissTimeout: 5000 });
      }
    } catch (error) {
      console.error("Error updating phase:", error);
      addToast("Something went wrong while updating.", { appearance: "error", autoDismiss: true, autoDismissTimeout: 5000 });
    }
  };

  const handleUpdateScheme = async (schemaIndex, phase, scheme) => {
    const body = {
      towerId: schemaData[schemaIndex].towerId,
      phaseId: phase._id,
      schemeId: scheme._id,
      percent: scheme.percent,
      days: scheme.days,
      isActive: scheme.isActive,
    };

    try {
      const response = await api.updateSchemaDetails(body);
      console.log("Update Scheme Response:", response?.data);

      if (response?.status === 200) {
        addToast("Scheme updated successfully!", {
          appearance: "success",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      } else if (response?.status === 401) {
        addToast("Session expired. Please login again.", { appearance: "error", autoDismiss: true, autoDismissTimeout: 5000 });
        localStorage.removeItem(utilis.string.localStorage.sessionId);
        localStorage.removeItem(utilis.string.localStorage.userData);
        navigate('/');
      } else {
        addToast("Failed to update scheme. Please try again.", { appearance: "error", autoDismiss: true, autoDismissTimeout: 5000 });
      }
    } catch (error) {
      console.error("Error updating scheme:", error);
      addToast("Something went wrong while updating.", { appearance: "error", autoDismiss: true, autoDismissTimeout: 5000 });
    }
  };

  const storedData = JSON.parse(localStorage.getItem('AdminDetails')) || {};
  const managementId = storedData?.data?.data?._id || null;

  const [projectStartDate, setProjectStartDate] = useState(null);
  const [projectEndDate, setProjectEndDate] = useState(null);

  // You still have your local phases state for Add Schema form
  const [phases, setPhases] = useState([
    {
      name: '',
      startDate: null,
      endDate: null,
      isActive: true,
      scheme: [{ percent: 0, days: 0 }],
    },
  ]);

  useEffect(() => {
    console.log('📦 Received towerId in Step 9:', towerId);
  }, [towerId]);

  const handleAddPhase = () => {
    setPhases(prev => [
      ...prev,
      {
        name: '',
        startDate: null,
        endDate: null,
        isActive: true,
        scheme: [{ percent: 0, days: 0 }],
      },
    ]);
  };

  const handleRemovePhase = (index) => {
    const updated = [...phases];
    updated.splice(index, 1);
    setPhases(updated);
  };

  const handlePhaseChange = (index, key, value) => {
    const updated = [...phases];
    updated[index][key] = value;
    setPhases(updated);
  };

  const handleSchemeChange = (phaseIndex, schemeIndex, key, value) => {
    const updated = [...phases];
    updated[phaseIndex].scheme[schemeIndex][key] = value;
    setPhases(updated);
  };

  const handleAddScheme = (phaseIndex) => {
    const updated = [...phases];
    updated[phaseIndex].scheme.push({ percent: 0, days: 0 });
    setPhases(updated);
  };

  const handleRemoveScheme = (phaseIndex, schemeIndex) => {
    const updated = [...phases];
    updated[phaseIndex].scheme.splice(schemeIndex, 1);
    setPhases(updated);
  };

  const handleSubmit = async () => {
    if (!projectStartDate || !projectEndDate) {
      alert('Please select both project start and end dates.');
      return;
    }
    const body = {
      towerId,
      createdBy: managementId,
      isActive: true,
      projectStartDate: projectStartDate?.toISOString(),
      projectEndDate: projectEndDate?.toISOString(),
      phases: phases.map(phase => ({
        name: phase.name,
        startDate: phase.startDate?.toISOString(),
        endDate: phase.endDate?.toISOString(),
        isActive: true,
        scheme: phase.scheme.map(s => ({
          percent: s.percent,
          days: s.days,
        })),
      })),
    };

    console.log('📤 Submitting:', body);

    try {
      const response = await api.addTowersStep9(body);
      console.log('✅ API Response:', response);
       if (response.data.success) {
        addToast("Schema Added successfully", {
          appearance: "success",
          autoDismiss: true,
        });
       // Close the form
  setShowAddSchemaForm(false);
  
  // Reset form fields
  setProjectStartDate(null);
  setProjectEndDate(null);
  setPhases([
    {
      name: '',
      startDate: null,
      endDate: null,
      isActive: true,
      scheme: [{ percent: 0, days: 0 }],
    },
  ]);
  

        
      } 
    } catch (error) {
      console.error('❌ Submission failed:', error);
      alert('Submission failed.');
    }
  };

  return (
    <>
      <Dashheader />
      <div className="updateschema-container">
        <div className="updateschema-header">
          <h2 className="updateschema-title">Update Payment Schemes</h2>
       
        </div>

        <div className="updateschema-content">
          {schemaData.length > 0 ? (
            schemaData.map((schema, schemaIndex) => (
              <div key={schema._id} className="schema-block" style={{ marginBottom: 40, border: "1px solid #ccc", padding: 20 }}>
                {/* <h2>Schema #{schemaIndex + 1} - Tower Id: {schema.towerId}</h2> */}
                {schema.phases.length > 0 ? (
                  schema.phases.map((phase, phaseIndex) => (
                    <div key={phase._id} className="updateschema-phase-card">
                      <div className="updateschema-phase-header">
                        <div className="updateschema-phase-title">
                          <h3 className="updateschema-phase-name">Phase: {phase.name}</h3>
                          <button
                            className={`updateschema-phase-toggle ${phase.isActive ? 'active' : 'inactive'}`}
                            onClick={() => updatePhaseStatus(schemaIndex, phaseIndex, !phase.isActive)}
                          >
                            {phase.isActive ? 'Active' : 'Inactive'}
                          </button>
                          <div className="updateschema-phase-actions">
                            <button
                              className="updateschema-btn updateschema-btn-primary"
                              onClick={() => handleUpdatePhase(schemaIndex, phase)}
                            >
                              Update Phase
                            </button>
                          </div>
                        </div>

                        <div className="updateschema-phase-dates">
                          <div className="updateschema-date-group">
                            <label className="updateschema-date-label">Start Date:</label>
                            <input
                              type="datetime-local"
                              className="updateschema-date-input"
                              value={new Date(phase.startDate).toISOString().slice(0, 16)}
                              onChange={(e) => updatePhaseDate(schemaIndex, phaseIndex, 'startDate', new Date(e.target.value).toISOString())}
                            />
                          </div>
                          <div className="updateschema-date-group">
                            <label className="updateschema-date-label">End Date:</label>
                            <input
                              type="datetime-local"
                              className="updateschema-date-input"
                              value={new Date(phase.endDate).toISOString().slice(0, 16)}
                              onChange={(e) => updatePhaseDate(schemaIndex, phaseIndex, 'endDate', new Date(e.target.value).toISOString())}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="updateschema-schemes-section">
                        <h4 className="updateschema-schemes-title">Payment Schemes ({phase.scheme?.length || 0})</h4>
                        <div className="updateschema-schemes-grid">
                          {phase.scheme?.map((scheme, schemeIndex) => (
                            <div key={scheme._id} className="updateschema-scheme-item">
                              <div className="updateschema-scheme-header">
                                <span className="updateschema-scheme-number">
                                  Scheme {schemeIndex + 1}
                                </span>
                                <button
                                  className={`updateschema-scheme-toggle ${scheme.isActive ? 'active' : 'inactive'}`}
                                  onClick={() => updateSchemeStatus(schemaIndex, phaseIndex, schemeIndex, !scheme.isActive)}
                                >
                                  {scheme.isActive ? 'Active' : 'Inactive'}
                                </button>
                              </div>

                              <div className="updateschema-scheme-details">
                                <div className="updateschema-detail-row">
                                  <label className="updateschema-label">Percentage:</label>
                                  <input
                                    type="number"
                                    className="updateschema-input"
                                    value={scheme.percent}
                                    min="0"
                                    max="100"
                                    onChange={(e) =>
                                      updateSchemeValue(schemaIndex, phaseIndex, schemeIndex, 'percent', parseInt(e.target.value) || 0)
                                    }
                                  />
                                  <span className="updateschema-unit">%</span>
                                </div>

                                <div className="updateschema-detail-row">
                                  <label className="updateschema-label">Days:</label>
                                  <input
                                    type="number"
                                    className="updateschema-input"
                                    value={scheme.days}
                                    min="0"
                                    onChange={(e) =>
                                      updateSchemeValue(schemaIndex, phaseIndex, schemeIndex, 'days', parseInt(e.target.value) || 0)
                                    }
                                  />
                                  <span className="updateschema-unit">days</span>
                                </div>

                                <div className="updateschema-scheme-actions">
                                  <button
                                    className="updateschema-btn updateschema-btn-primary"
                                    onClick={() => handleUpdateScheme(schemaIndex, phase, scheme)}
                                  >
                                    Update Scheme
                                  </button>
                                </div>
                                
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No phases found</p>
                )}
                
              </div>
              
            ))
          ) : (
            <div className="updateschema-no-data">
              <p className="updateschema-no-data-text">No payment schemas found</p>
            </div>
          )}
        </div>
           {/* 🔹 Add New Schema Button */}
          <button
            className="updateschema-btn updateschema-btn-primary"
            onClick={() => setShowAddSchemaForm(!showAddSchemaForm)}
          >
            {showAddSchemaForm ? 'Close Add Schema' : 'Add New Schema'}
          </button>

        {/* 🔽 Add Schema Form (visible when button clicked) */}
        {showAddSchemaForm && (
          <div className="addtowers">
            <h2>Add New Phase</h2>
            <div className="addtowers-form">
              <Form.Item label="Project Start Date" required>
                <DatePicker value={projectStartDate ? dayjs(projectStartDate) : null} onChange={date => setProjectStartDate(date)} />
              </Form.Item>
              <Form.Item label="Project End Date" required>
                <DatePicker value={projectEndDate ? dayjs(projectEndDate) : null} onChange={date => setProjectEndDate(date)} />
              </Form.Item>
              {phases.map((phase, index) => (
                <div key={index} className="phase-block" style={{ marginBottom: 32, borderBottom: '1px solid #eee', paddingBottom: 16 }}>
                  <h4>Phase {index + 1}</h4>
                  <Form.Item label="Phase Name">
                    <Input value={phase.name} onChange={e => handlePhaseChange(index, 'name', e.target.value)} />
                  </Form.Item>
                  <Space style={{ marginBottom: 8 }}>
                    <Form.Item label="Start Date">
                      <DatePicker value={phase.startDate ? dayjs(phase.startDate) : null} onChange={date => handlePhaseChange(index, 'startDate', date)} />
                    </Form.Item>
                    <Form.Item label="End Date">
                      <DatePicker value={phase.endDate ? dayjs(phase.endDate) : null} onChange={date => handlePhaseChange(index, 'endDate', date)} />
                    </Form.Item>
                  </Space>
                  <Divider orientation="left">Scheme</Divider>
                  {phase.scheme.map((s, sIdx) => (
                    <Space key={sIdx} align="baseline" style={{ display: 'flex', marginBottom: 8 }}>
                      <Form.Item label="Percent">
                        <InputNumber value={s.percent} min={0} max={100} onChange={value => handleSchemeChange(index, sIdx, 'percent', value)} />
                      </Form.Item>
                      <Form.Item label="Days">
                        <InputNumber value={s.days} min={0} onChange={value => handleSchemeChange(index, sIdx, 'days', value)} />
                      </Form.Item>
                      {phase.scheme.length > 1 && <MinusCircleOutlined onClick={() => handleRemoveScheme(index, sIdx)} />}
                    </Space>
                  ))}
                  <Button type="dashed" icon={<PlusOutlined />} onClick={() => handleAddScheme(index)}>
                    Add Scheme
                  </Button>
                  {phases.length > 1 && (
                    <Button danger type="link" onClick={() => handleRemovePhase(index)} style={{ marginTop: 8 }}>
                      Remove Phase
                    </Button>
                  )}
                </div>
              ))}
              <Button type="primary" icon={<PlusOutlined />} onClick={handleAddPhase} style={{ marginBottom: 24 }}>
                Add Phase
              </Button>
              <br />
              <Button type="primary" onClick={handleSubmit}>
                Submit All Phases
              </Button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UpdateSchemas;
